import React from 'react';
import { withTheme } from 'styled-components';
import { Breadcrumbs } from 'shared-components';
import { Helmet } from 'react-helmet-async';

export default withTheme(({ theme, children, breadcrumbs }) => (
  <>
    <Helmet key="helmet">
      <link rel="shortcut icon" href={theme.brand.favicon} />
      <title>My Card</title>
    </Helmet>
    {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
    {children}
  </>
));
